export default __webpack_public_path__ + "end-device-placeholder.0779507e1efe77288341.svg";